import React from "react";
import {
  MonitorIcon,
  SmartphoneIcon,
  LogOutIcon,
  MapPinIcon,
  GlobeSmallIcon,
  ClockIcon,
} from "./PrivacyIcons";

const SESSIONS = [
  {
    id: 1,
    name: "Chrome on Windows",
    type: "desktop",
    location: "Mumbai, India",
    ip: "192.168.1.1",
    time: "Now",
    current: true,
  },
  {
    id: 2,
    name: "Safari on iPhone",
    type: "mobile",
    location: "Mumbai, India",
    ip: "192.168.1.2",
    time: "2 hours ago",
    current: false,
  },
  {
    id: 3,
    name: "Firefox on macOS",
    type: "desktop",
    location: "Pune, India",
    ip: "192.168.1.3",
    time: "Yesterday",
    current: false,
  },
];

const PrivacyActiveSessions = () => {
  return (
    <div className="v2-privacy-pg-card">
      <div className="v2-privacy-pg-card__header v2-privacy-pg-card__header--between">
        <div className="v2-privacy-pg-card__header-left">
          <div className="v2-privacy-pg-card__icon-wrap" style={{ background: "#fef2f2" }}>
            <MonitorIcon size={20} color="#eb1414" />
          </div>
          <div>
            <h3 className="v2-privacy-pg-card__title">Active Sessions</h3>
            <p className="v2-privacy-pg-card__subtitle">
              Devices currently logged into your account
            </p>
          </div>
        </div>
        <button className="v2-privacy-pg-btn-outline">
          <LogOutIcon size={16} color="#1a2233" />
          <span>Log Out All Others</span>
        </button>
      </div>

      <div className="v2-privacy-pg-card__body">
        <div className="v2-privacy-pg-sessions">
          {SESSIONS.map((session) => (
            <div className="v2-privacy-pg-session" key={session.id}>
              <div className="v2-privacy-pg-session__left">
                <div className="v2-privacy-pg-session__device-icon">
                  {session.type === "mobile" ? (
                    <SmartphoneIcon size={20} color="#6b7280" />
                  ) : (
                    <MonitorIcon size={20} color="#6b7280" />
                  )}
                </div>
                <div className="v2-privacy-pg-session__info">
                  <div className="v2-privacy-pg-session__name-row">
                    <span className="v2-privacy-pg-session__name">{session.name}</span>
                    {session.current && (
                      <span className="v2-privacy-pg-session__badge">Current</span>
                    )}
                  </div>
                  <div className="v2-privacy-pg-session__meta">
                    <span className="v2-privacy-pg-session__meta-item">
                      <MapPinIcon size={14} color="#9ca3af" />
                      {session.location}
                    </span>
                    <span className="v2-privacy-pg-session__meta-item">
                      <GlobeSmallIcon size={14} color="#9ca3af" />
                      {session.ip}
                    </span>
                    <span className="v2-privacy-pg-session__meta-item">
                      <ClockIcon size={14} color="#9ca3af" />
                      {session.time}
                    </span>
                  </div>
                </div>
              </div>
              {!session.current && (
                <button className="v2-privacy-pg-session__logout">
                  <LogOutIcon size={18} color="#6b7280" />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyActiveSessions;
